import PropTypes from 'prop-types';

import PaymentIcon from '../Icons/PaymentIcon';

import { MenuTitle, NavIcon, NavLinkStyled, NavText } from './Menu.parts';

function AutomaticAccountingMenu({ handleClose }) {
  return (
    <>
      <MenuTitle variant="h1">Accounting</MenuTitle>
      <NavLinkStyled to="/final-invoicing" permission="automaticaccounting:start" onClick={handleClose}>
        <NavIcon>
          <PaymentIcon />
        </NavIcon>
        <NavText variant="h2"> Final Invoicing</NavText>
      </NavLinkStyled>
      <NavLinkStyled to="/mass-invoicing" permission="automaticaccounting:start" onClick={handleClose}>
        <NavIcon>
          <PaymentIcon />
        </NavIcon>
        <NavText variant="h2"> Mass Invoicing</NavText>
      </NavLinkStyled>
      <NavLinkStyled to="/reimbursement" permission="automaticaccounting:start" onClick={handleClose}>
        <NavIcon>
          <PaymentIcon />
        </NavIcon>
        <NavText variant="h2"> Reimbursement</NavText>
      </NavLinkStyled>
    </>
  );
}

AutomaticAccountingMenu.propTypes = {
  handleClose: PropTypes.func.isRequired,
};

export default AutomaticAccountingMenu;
